import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';

export function iniSliderPosts() {
  const swiper = new Swiper('.o-last-posts__slider', {
    loop: true,
    preloadImages: true,
    watchSlidesProgress: true,
    watchSlidesVisibility: true,
    loopAdditionalSlides: 2,
    spaceBetween: 40,
    modules: [Navigation],
    navigation: {
      nextEl: '.o-last-posts__next',
      prevEl: '.o-last-posts__prev',
    },
    breakpoints: {
      768: {
        slidesPerView: 2,
        spaceBetween: 20,
      },
      1200: {
        slidesPerView: 2,
        spaceBetween: 40,
      },
    },
  });
}
